
//  dp Per page data for production 
// Final Values for DB- 
// export const companyPerPage = "2000";
// export const peoplePerPage = "3500";
// Todo Now 
export const companyPerPage = "3000";
export const peoplePerPage = "6000";

// dp Per page data for Test 
// export const companyPerPage = "40";
// export const peoplePerPage = "15";


// apolocompanyPerPage /apolopeoplePerPage  For Production Use 
export const apolocompanyPerPage = 99;
export const apolopeoplePerPage = 100;

// // // per page appolo For Production Use   
export const companypages = 30;
export const peoplepages = 40;



// //  per page appolo For Testing Use   
// export const  companypages = 1;
// export const  peoplepages = 1;


// // apolocompanyPerPage /apolopeoplePerPage  For testing Use  
// export const apolocompanyPerPage = 3;
// export const apolopeoplePerPage = 50;
